import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { English } from "../../constant/EnglishFallback";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Box,
  Typography,
  IconButton,
  TextField,
  Avatar,
  Paper,
  Chip,
  Checkbox,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  ListItemSecondaryAction
} from "@mui/material";
import { styled } from "@mui/material/styles";
import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import {
  SAVE_CHAT_GROUP_USERS,
  SEARCH_USERS_MEMBERS,
  GET_MY_CHAT_GROUPS_USERS,
  GET_MY_CHAT_GROUPS_USERS_BY_USER_ID
} from "../../constant/Apipath";
import { setChatState } from "../../redux/actions/actions";
import { Getrequestcall } from "../../request/Getrequest";
import { Postrequestcall } from "../../request/Postrequest";
import ReferralModal from "../common/ReferralModal";
import { debounce, set } from "lodash";
import { useNavigate } from "react-router-dom";
import { navigateToChatPage } from "../../common/Helper";
import Loader from "../../common/Loader";

// Colors
const BIGrey = "#888";
const BIBlue = "#1976d2";

const ScrollableUserList = styled(Paper)(({ theme }) => ({
  background: "#fff",
  borderRadius: 8,
  maxHeight: 400,
  overflowY: "auto",
  marginBottom: theme.spacing(2),
  "&::-webkit-scrollbar": {
    width: 0,
    display: "none"
  },
  "&::-webkit-scrollbar-thumb": {
    background: "#e0e0e0",
    borderRadius: 3
  }
}));

const SelectedUsersScroll = styled(Box)(({ theme }) => ({
  display: "flex",
  overflowX: "auto",
  marginBottom: theme.spacing(2),
  gap: theme.spacing(1),
  scrollbarWidth: "none",
  "&::-webkit-scrollbar": {
    height: 0,
    display: "none"
  },
  "&::-webkit-scrollbar-thumb": {
    background: "#e0e0e0",
    borderRadius: 3
  }
}));

const StyledDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialog-paper": {
    width: "100%",
    maxWidth: 565,
    borderRadius: 18,
    background: "#fff",
    boxShadow: "0 8px 32px rgba(0,0,0,0.12)",
    padding: theme.spacing(0, 0, 2, 0)
  }
}));

const SearchBox = styled(Paper)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(1, 2),
  marginBottom: theme.spacing(2),
  marginTop: "10px",
  borderRadius: 12,
  background: "#fff",
  border: "1px solid #e0e0e0"
}));

const StyledChip = styled(Chip)(({ theme }) => ({
  margin: theme.spacing(0.5),
  background: "#e3eafc",
  fontWeight: 500,
  height: 40,
  color: BIBlue,
  ".MuiAvatar-root": {
    width: 28,
    height: 28
  }
}));

const EmptyState = styled(Box)(({ theme }) => ({
  textAlign: "center",
  marginTop: theme.spacing(5),
  color: BIGrey
}));

const BlueFab = styled(IconButton)(({ theme }) => ({
  background: BIBlue,
  color: "#fff",
  width: 48,
  height: 48,
  borderRadius: "50%",
  boxShadow: "0 2px 8px rgba(25, 118, 210, 0.18)",
  "&:hover": {
    background: "#1251a3"
  }
}));

export default function NewChatModal({
  open,
  onClose,
  title,
  imageUrl,
  from,
  getUrl,
  getChatGroupUser,
  setMessageLoader
}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { multiLanguageData, loginData, chatState, chatgrou } = useSelector((state) => state?.main);
  const LanguageData = multiLanguageData?.Chat || {};
  const {
    TEXT_NEW_CHAT = English.Chat.TEXT_NEW_CHAT,
    TEXT_TYPE_TO_SEARCH = English.Chat.TEXT_TYPE_TO_SEARCH,
    TEXT_CANT_FIND_SOMEONE = English.Chat.TEXT_CANT_FIND_SOMEONE,
    TEXT_INVITE_THEM = English.Chat.TEXT_INVITE_THEM,
    PLACEHOLDER_TEXT_SEACRCH_USERS = English.Chat.PLACEHOLDER_TEXT_SEACRCH_USERS,
    TEXT_MASSAGE = English.Chat.TEXT_MASSAGE,
    TEXT_SHARE = English.Chat.TEXT_SHARE,
    TEXT_COPY_LINK = English.Chat.TEXT_COPY_LINK
  } = LanguageData || {};

  const [selectedUsers, setSelectedUsers] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [showInviteModal, setShowInviteModal] = useState(false);

  const [users, setUsers] = useState([]);
  const [primaryUsers, setPrimaryUsers] = useState([]);
  const [addingUser, setAddingUser] = useState(false);
  const [initial, setInitial] = useState(true);
  const [loading, setLoading] = useState(false);
  const [hasLoaded, setHasLoaded] = useState(false);

  // Filtered static users (remove duplicates by userId)
  useEffect(() => {
    if (open) {
      setLoading(true);
      setHasLoaded(false);
      getGroupsdata();
    }
  }, [open]);

  // DEBOUNCE TO PREVENT API CALL ON EACH KEY STROKE
  useEffect(() => {
    const debouncedGetInitialData = debounce((searchText) => {
      onChangeSearchText(searchText);
    }, 500);
    debouncedGetInitialData(inputValue);
    return () => {
      debouncedGetInitialData.cancel();
    };
  }, [inputValue]);

  const getGroupsdata = async () => {
    setLoading(true);
    setHasLoaded(false);
    try {
      let getChats = await Getrequestcall(
        `${GET_MY_CHAT_GROUPS_USERS_BY_USER_ID}/${loginData?.userInformation?.UserId}`,
        loginData?.accessToken
      );
      if (getChats?.status === 200) {
        getChats = getChats?.data?.data || [];
        const uniqueUsers = getChats?.reduce((acc, current) => {
          // Remove duplicates based on userId
          const exists = acc.find((item) => item.userId === current.userId);
          if (!exists) {
            acc.push(current);
          }
          return acc;
        }, []);
        let getUsers = uniqueUsers.map((user) => ({
          ...user,
          name: `${user?.firstName} ${user?.lastName}`,
          selected: false
        }));
        setUsers(getUsers);
        setPrimaryUsers(getUsers);
      }
      setLoading(false);
      setHasLoaded(true);
    } catch (error) {
      console.log("Get Group List API Error: ", error);
      setLoading(false);
      setHasLoaded(true);
    }
  };

  // Handle selection from static user list
  const onSelectUsers = (user) => {
    const identifier = user.chatGroupId || user.userId;
    const actualUserId = user.actualUserId || user.userId;

    // Check if this actual user is already selected
    const alreadySelected = selectedUsers?.some((u) => {
      const uActualId = u.actualUserId || u.userId;
      return uActualId === actualUserId;
    });

    if (alreadySelected) {
      // Deselect - remove all instances of this user
      setSelectedUsers((prevSelected) =>
        prevSelected?.filter((u) => {
          const uActualId = u.actualUserId || u.userId;
          return uActualId !== actualUserId;
        })
      );
      setUsers((prevUsers) =>
        prevUsers.map((u) => {
          const uActualId = u.actualUserId || u.userId;
          return uActualId === actualUserId ? { ...u, selected: false } : u;
        })
      );
    } else {
      // Select
      setSelectedUsers((prevSelected) => [...prevSelected, { ...user, selected: true }]);
      setUsers((prevUsers) =>
        prevUsers.map((u) => {
          const uIdentifier = u.chatGroupId || u.userId;
          return uIdentifier === identifier ? { ...u, selected: true } : u;
        })
      );
    }
  };

  const onChangeSearchText = async (searchText) => {
    setLoading(true);
    if (searchText !== "") {
      try {
        const getUsers = await Getrequestcall(
          `${SEARCH_USERS_MEMBERS}/${loginData?.userInformation?.UserId}/${Number(0)}/${searchText}`,
          loginData?.accessToken
        );
        if (getUsers.status === 200) {
          const newUsers = getUsers?.data?.data;
          // Get all selected actual user IDs
          let selectedActualUserIds = selectedUsers?.map((u) => u.actualUserId || u.userId);
          setUsers(
            newUsers.map((user) => ({
              ...user,
              name: `${user?.firstName} ${user?.lastName}`,
              selected: selectedActualUserIds.includes(user.userId)
            }))
          );
        }
      } catch (error) {
        console.error("onChangeSearchText-> Error When Searching User Member: ", error);
      } finally {
        setLoading(false);
      }
    } else {
      // Get all selected actual user IDs
      let selectedActualUserIds = selectedUsers?.map((u) => u.actualUserId || u.userId);
      let getUsers = primaryUsers?.map((item) => ({
        ...item,
        selected: selectedActualUserIds?.includes(item.actualUserId || item.userId)
      }));
      if (initial !== true) {
        setUsers(getUsers);
      } else {
        setInitial(false);
      }
    }
    setLoading(false);
  };

  const handleClose = () => {
    onClose();
    setSelectedUsers([]);
    setInputValue("");
    setInitial(true);
    setUsers([]);
    setHasLoaded(false);
  };

  // Group creation handler
  const handleCreateGroup = async () => {
    if (from === "newChat") {
      setMessageLoader(true);
    }
    setAddingUser(true);
    try {
      // If only one existing chat is selected, just navigate to it (only for new chat, not for adding members)
      if (selectedUsers.length === 1 && selectedUsers[0].fullChatData && from !== "showMembers") {
        const selectedChat = selectedUsers[0].fullChatData;
        navigateTochat(selectedChat.chatGroupId);
        handleClose();
        return;
      }

      // Separate existing chats and new searched users
      const existingChats = selectedUsers.filter((u) => u.fullChatData);
      const newSearchedUsers = selectedUsers.filter((u) => !u.fullChatData && u.userId);

      let userIdsToAdd = [];

      // Get user IDs from existing chats
      if (existingChats.length > 0) {
        for (const chat of existingChats) {
          try {
            const res = await Getrequestcall(
              `${GET_MY_CHAT_GROUPS_USERS}/${loginData?.userInformation?.UserId}/${chat.chatGroupId}`,
              loginData?.accessToken
            );
            if (res?.status === 200 && res?.data?.data) {
              // Extract user IDs from chat group members (excluding current user)
              const memberUserIds = res.data.data
                .filter((member) => member.userId !== loginData?.userInformation?.UserId)
                .map((member) => member.userId);
              userIdsToAdd.push(...memberUserIds);
            }
          } catch (error) {
            console.error("Error fetching chat group users:", error);
            setAddingUser(false);
          }
        }
      }

      // Add new searched users
      if (newSearchedUsers.length > 0) {
        userIdsToAdd.push(...newSearchedUsers.map((u) => u.userId));
      }
      // Remove duplicates
      userIdsToAdd = [...new Set(userIdsToAdd)];
      if (userIdsToAdd.length === 0) {
        setAddingUser(false);
        return;
      }
      // Create the group with all users
      let getRequest = userIdsToAdd.map((userId) => ({
        Id: 0,
        ChatGroupId: chatState?.chatGroupId || 0,
        UserId: Number(userId),
        ModifiedBy: Number(loginData?.userInformation?.UserId),
        Muted: false
      }));
      const chatGroupObj = {
        UserId: Number(loginData?.userInformation?.UserId),
        ReturnRecordId: true,
        ReturnRecordError: true,
        SaveList: getRequest
      };
      const getResponse = await Postrequestcall(
        SAVE_CHAT_GROUP_USERS,
        chatGroupObj,
        loginData?.accessToken
      );
      if (getResponse.status === 201) {
        let getChatgroupId = getResponse?.data?.data[0]?.objData?.chatGroupId;
        let isGroupExist = getResponse?.data?.data[0]?.objData?.isGroupExit;
        // If adding to existing group from ShowMembersModal
        if (from === "showMembers" && getChatGroupUser) {
          getChatGroupUser(); // Refresh the members list
          handleClose();
        } else {
          navigateTochat(getChatgroupId, isGroupExist);
          handleClose();
        }
      }
    } catch (error) {
      console.error("Error creating chat group:", error);
    } finally {
      setAddingUser(false);
    }
  };

  const navigateTochat = async (getChatgroupId, isGroupExist) => {
    if (
      from === "Company" ||
      from === "Manufacture" ||
      from === "Product" ||
      from === "Trade" ||
      from === "Project"
    ) {
      navigateToChatPage(navigate, dispatch, from, title, imageUrl, getChatgroupId, getUrl);
    } else {
      if (from === "newChat") {
        const chatState = {
          chatGroupId: getChatgroupId,
          from: isGroupExist ? "existChat" : "newChat",
          refresh: new Date().getTime()
        };
        dispatch(setChatState(chatState));
      } else {
        if (getChatGroupUser) {
          getChatGroupUser();
        }
      }
    }
  };

  return (
    <>
      <StyledDialog open={open} onClose={handleClose} fullWidth>
        <DialogTitle sx={{ pb: 0 }}>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="h6" fontWeight={500} color={"black"}>
              {TEXT_NEW_CHAT}
            </Typography>
            <IconButton onClick={handleClose} size="small">
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent sx={{ pt: 1, pb: 0 }}>
          <SearchBox elevation={0}>
            <SearchIcon fontSize="medium" sx={{ color: "black", mr: 1 }} />
            <TextField
              variant="standard"
              placeholder={"Search New Users"}
              value={inputValue}
              onChange={(e) => {
                const sanitized = e.target.value.replace(/[^A-Za-z0-9 ]/g, "").replace(/^\s+/, "");
                setInputValue(sanitized);
                // onChangeSearchText(sanitized);
              }}
              InputProps={{
                disableUnderline: true,
                sx: { fontSize: 16, ml: 1 }
              }}
              fullWidth
            />
          </SearchBox>
          {/* Selected users chips (WhatsApp style, horizontal scroll) */}
          {selectedUsers.length > 0 && (
            <SelectedUsersScroll>
              {selectedUsers.map((user) => (
                <StyledChip
                  key={user?.chatGroupId || user?.userId}
                  avatar={<Avatar alt={user?.name} src={user?.pictureUrl} />}
                  label={user?.name}
                  onDelete={() => {
                    const identifier = user?.chatGroupId || user?.userId;
                    setSelectedUsers(
                      selectedUsers.filter((u) => (u?.chatGroupId || u?.userId) !== identifier)
                    );
                    setUsers(
                      users.map((u) =>
                        (u?.chatGroupId || u?.userId) === identifier ? { ...u, selected: false } : u
                      )
                    );
                  }}
                />
              ))}
            </SelectedUsersScroll>
          )}
          {/* Static user list with checkboxes, scrollable */}
          <Box sx={{ mb: 2 }}>
            {loading || !hasLoaded ? (
              <Loader />
            ) : hasLoaded && users?.length === 0 ? (
              <EmptyState>
                <img
                  src="https://cdn-icons-png.flaticon.com/512/4076/4076549.png"
                  alt="No user"
                  width={90}
                  style={{ opacity: 0.7, marginBottom: 12 }}
                />
                <Typography variant="body2" sx={{ fontSize: "15px" }}>
                  No data found
                </Typography>
              </EmptyState>
            ) : hasLoaded ? (
              <ScrollableUserList variant="outlined">
                <List dense>
                  {users?.map((user) => (
                    <ListItem
                      key={user?.chatGroupId || user?.userId}
                      button
                      onClick={() => onSelectUsers(user)}
                      selected={user?.selected || false}
                      sx={{
                        borderRadius: 1,
                        mb: 0.5,
                        cursor: "pointer",
                        "&.Mui-selected": { background: "#e3eafc" }
                      }}>
                      <ListItemAvatar>
                        <Avatar src={user?.pictureUrl}>{user?.firstName}</Avatar>
                      </ListItemAvatar>
                      <ListItemText primary={user?.name} secondary={user?.role} />
                      <ListItemSecondaryAction>
                        <Checkbox
                          edge="end"
                          checked={user?.selected || false}
                          tabIndex={-1}
                          disableRipple
                          onChange={() => onSelectUsers(user)}
                        />
                      </ListItemSecondaryAction>
                    </ListItem>
                  ))}
                </List>
              </ScrollableUserList>
            ) : null}
          </Box>
          {/* Arrow icon button at the bottom right */}
          <Box display="flex" alignItems="center">
            <Box flex={1} textAlign="center">
              <Typography style={{ fontSize: "14px", color: BIGrey, display: "inline-block" }}>
                {TEXT_CANT_FIND_SOMEONE}
                <span
                  style={{ color: BIBlue, fontWeight: 600, cursor: "pointer" }}
                  onClick={() => setShowInviteModal(true)}>
                  {"  "}
                  {TEXT_INVITE_THEM}
                </span>
              </Typography>
            </Box>
            <BlueFab
              disabled={selectedUsers.length === 0 || addingUser}
              onClick={handleCreateGroup}
              loading={addingUser}
              aria-label="Create Group"
              sx={{ ml: 2 }}>
              <ArrowForwardIcon fontSize="medium" />
            </BlueFab>
          </Box>
        </DialogContent>
      </StyledDialog>

      {showInviteModal && (
        <ReferralModal
          open={showInviteModal}
          TEXT_MASSAGE={TEXT_MASSAGE}
          TEXT_SHARE={TEXT_SHARE}
          TEXT_COPY_LINK={TEXT_COPY_LINK}
          onClose={() => {
            setShowInviteModal(false);
          }}
        />
      )}
    </>
  );
}
